import { render, staticRenderFns } from "./SrTooltip.vue?vue&type=template&id=4b7c5aa3"
import script from "./SrTooltip.vue?vue&type=script&lang=js"
export * from "./SrTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports